let connect = require("react-redux").connect;
import React from "react";

let actions = require("../actions/actions");

class ModerationSaveForLaterSearch extends React.Component {
    render() {
        return (
            <section className="creator-search">
                <div className="input-group input-group-lg">
                    <span className="input-group-addon" id="sizing-addon1">
                        <div className="ui_search" />
                    </span>
                    <input
                        type="text"
                        className="form-control search-input"
                        ref="search-save-for-later"
                        placeholder="Search for Saved Upload..."
                        aria-describedby="sizing-addon1"
                        onKeyUp={this.searchSaveForLater.bind(this)}
                    />
                </div>
            </section>
        );
    }

    searchSaveForLater(e) {
        let searchTerm = encodeURIComponent(
            this.refs["search-save-for-later"].value
        );
        if (searchTerm === "") {
            this.props.fetchSavedUploads("");
        } else if (searchTerm.length > 2) {
            this.props.searchSavedUploads(searchTerm);
        }
    }
}

module.exports = connect(null, {
    fetchSavedUploads: actions.fetchSavedUploads,
    searchSavedUploads: actions.searchSavedUploads
})(ModerationSaveForLaterSearch);
